/** Number helpers — byte-for-byte the original `n`, `f2`, `f3`, `pct`. */

/** parseFloat with 0 for anything non-finite. */
export function n(v: unknown): number {
  const x = parseFloat(v as string);
  return Number.isFinite(x) ? x : 0;
}

/** Round to 2 decimals, fixed notation ("1.50"). */
export function f2(v: unknown): string {
  return (Math.round(n(v) * 100) / 100).toFixed(2);
}

/** Round to 3 decimals, shortest notation ("0.033", "1.5"). Values stored in sheets are f3 strings. */
export function f3(v: unknown): string {
  return (Math.round(n(v) * 1000) / 1000).toString();
}

/** Percentile with linear interpolation, i = (len − 1) × p. Empty → 0. */
export function pct(a: number[], p: number): number {
  if (!a.length) return 0;
  const s = a.slice().sort((x, y) => x - y);
  const i = (s.length - 1) * p;
  const lo = Math.floor(i);
  return s[lo] + (s[Math.min(lo + 1, s.length - 1)] - s[lo]) * (i - lo);
}

/** HTML escape (for the few engine outputs that are HTML, e.g. the legacy CM check). */
export function esc(v: unknown): string {
  return String(v == null ? "" : v).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
}
